import * as Yup from "yup";

export const configurationSchema = Yup.object({
    min_edge_trim: Yup.string().required("Enter Min Edge Trim (mm)"),
    max_edge_trim: Yup.string().required("Enter Max Edge Trim (mm)"),
    min_good_piece_length: Yup.string().required("Enter Min Good Piece Length (m)"),
    min_final_length: Yup.string().required("Enter Min Final Length (m)"),
    max_welds_per_coil: Yup.string().required("Enter Max Welds per Coil(as per min final length)"),
    defect_item: Yup.array().required("Select Defect").min(1, "Select at least One User"),

    // password: Yup.string().required(" Enter Password"),
});
